enum ImageVariableType {
  Variable = 0,
  Still = 1,
}

export default ImageVariableType;
